export default __webpack_public_path__ + "static/media/restart-icon.1928b0e0.svg";